<div class="register-user page-wide" ngClass.xs="mobile">
  <h2>LOYALTY <span class="font-300">REWARDS</span></h2>

  <div class="greentree-split mt-section row">
    <div class="email-login col">
      <div class="login-container">
        <h3>Become a FHI rewards member</h3>
        <form [formGroup]="registerForm" (ngSubmit)="onRegisterSubmit()">
          <div class="two-column p-2">
            <div class="clr-form-control">
              <label for="name" class="form-label">First Name</label>
              <input formControlName="first_name" type="text" id="first_name" class="form-control" />
            </div>

            <div class="clr-form-control">
              <label for="name" class="form-label">Last Name</label>
              <input formControlName="last_name" type="text" id="last_name" class="form-control" />
            </div>
          </div>

          <div class="clr-form-control p-2">
            <label for="name" class="form-label">Email</label>
            <input formControlName="email" type="email" id="email" class="form-control" />
          </div>

          <div class="two-column p-2">
            <div class="clr-form-control">
              <label for="name" class="form-label">Password</label>
              <input formControlName="password" type="password" id="password" class="form-control" />
            </div>

            <div class="clr-form-control">
              <label for="name" class="form-label">Confirm Password</label>
              <input formControlName="password_confirmation" type="password" id="password_confirmation"
                    class="form-control" />
            </div>
          </div>
          <div class="d-grid gap-2">
            <button class="btn btn-primary" type="submit" [disabled]="registerBtnloading || !registerForm.valid">REGISTER</button>
          </div>
        </form>
      </div>
    </div>

    <div class="register col">
      <h3>Already have an account?</h3>
      <a routerLink="/login"><button class="btn btn-outline">SIGN IN</button></a>
    </div>
  </div>
</div>